import { history } from "../_helpers";
import { table } from "../_reducers/tables.reducer";

export const tablesServices = {
  getAllTables,
  getTableById,
  getTopCardTables,
  uploadDictionaryByTableId,
  addTable,
  getTableByConnectionId,
  getDataDictionaryByTableId,
  configureTableById,
  editTableById,
  editDataQualityById,
  getDataQualityByTableId,
  deleteDataQualityById,
  addConfiguredTableById,
  searchTables,
  getTablesFilters,
  applyTablesFilters,
  getDataDictionary,
  searchDataDictionary,
  activateTable,
  searchDataQuality,
  applyDataQualityFilters,
  fetchActiveTableByConnectionId
};

function getAllTables(offset = 0, limit = 10) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getTableById(tableId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/${tableId}`,
    requestOptions
  ).then(handleResponse);
}

function getTopCardTables() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/topCards`,
    requestOptions
  ).then(handleResponse);
}

function uploadDictionaryByTableId(formData, tableId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
    },
    body: formData,
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/dictionary/upload/${tableId}`,
    requestOptions
  ).then(handleResponse);
}

function addTable(formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table`,
    requestOptions
  ).then(handleResponse);
}

function getTableByConnectionId(connectionId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/connection/${connectionId}`,
    requestOptions
  ).then(handleResponse);
}

function getDataDictionaryByTableId(tableId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/dictionary/${tableId}`,
    requestOptions
  ).then(handleResponse);
}

function configureTableById(tableId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/configure/${tableId}`,
    requestOptions
  ).then(handleResponse);
}

function editTableById(tableId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/${tableId}`,
    requestOptions
  ).then(handleResponse);
}

function editDataQualityById(dataQualityConfigId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/dataQuality/${dataQualityConfigId}`,
    requestOptions
  ).then(handleResponse);
}

function getDataQualityByTableId(offset, limit, tableId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/dataQuality/${tableId}/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function deleteDataQualityById(dataQualityConfigId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/dataQuality/${dataQualityConfigId}`,
    requestOptions
  ).then(handleResponse);
}

function addConfiguredTableById(tableId, formData) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify(formData),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/${tableId}/configure`,
    requestOptions
  ).then(handleResponse);
}

function searchTables(searchText, offset = 0, limit = 10) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/search/${offset}/${limit}?searchText=${searchText}`,
    requestOptions
  ).then(handleResponse);
}

function getTablesFilters() {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/filters`,
    requestOptions
  ).then(handleResponse);
}

function applyTablesFilters(
    connection,
      user,
      workspace,
      startDate,
      endDate,
      search,
      offset = 0,
      limit = 10,
      endpoint,
      source,
) {
  let userToken = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": userToken.accessToken,
    },
    body: JSON.stringify({
      connection,
      user,
      workspace,
      startDate,
      endDate,
      search,
      endpoint,
      source,
    }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/filters/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function getDataDictionary(offset = 0, limit = 10, tableId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/dataDictionary/tableId/${tableId}/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function searchDataDictionary(searchText, offset = 0, limit = 10, tableId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/dataDictionary/search/tableId/${tableId}/${offset}/${limit}?searchText=${searchText}`,
    requestOptions
  ).then(handleResponse);
}

function activateTable(isActive, tableId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": user.accessToken,
    },
    body: JSON.stringify({ isActive }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/activate/${tableId}`,
    requestOptions
  ).then(handleResponse);
}

function searchDataQuality(searchText, offset, limit, tableId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/dataQuality/search/tableId/${tableId}/${offset}/${limit}?searchText=${searchText}`,
    requestOptions
  ).then(handleResponse);
}

function applyDataQualityFilters(
  functionType,
  functionName,
  searchText,
  offset,
  limit,
  tableId
) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": user.accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      functionType,
      functionName,
      searchText,
      offset,
      limit,
      tableId,
    }),
  };
  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/tables/dataQuality/filter/tableId/${tableId}/${offset}/${limit}`,
    requestOptions
  ).then(handleResponse);
}

function fetchActiveTableByConnectionId(connectionId) {
  let user = JSON.parse(localStorage.getItem("user"));
  const requestOptions = {
    method: "GET",
    headers: {
      "x-access-token": user.accessToken,
    },
  };

  return fetch(
    `${process.env.REACT_APP_BACKEND_API_URL}/api/v1/table/active/connection/${connectionId}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      // checking token expiry
      if (
        response.status === 401 &&
        data.message.includes("Invalid JWT token")
      ) {
        // redirecting to signin page
        history.push("/auth/signin");
        // removing local storage token
        localStorage.removeItem("user");
        return;
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
